import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
    fetchDevices, searchDevices, addDriver, fetchDrivers, verifyProject, deleteProject
} from '../../../../actions';
import { Form, Tabs, Tab, ButtonToolbar, Button, Row, Col, Modal, Spinner } from 'react-bootstrap';
import DeviceList from './DeviceList';
import DeviceImage from './DeviceImage';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faStar } from '@fortawesome/free-solid-svg-icons';
import { Trans, withTranslation } from 'react-i18next';

class DeviceSelect extends React.Component {

    constructor(props) {
        super(props);

        let initialFilter = [];
        // if ((localStorage.getItem("latestfw") || "true") === "true")
        //     initialFilter = ["latestfw"];
        // if ((localStorage.getItem("favouritesFilter") || "true") === "true")
        //     initialFilter = ["favouritesFilter"];
        this.state = {
            showedDevice: null,
            devices: null,
            searchString: '',
            filters: initialFilter,
            scope: 'cloud',
            buttonsActive: [true, false, false],
            activeKey: 0,
            sampleDevices: false,
            loader: false
        };

        this.cancelSelectedDevice = this.cancelSelectedDevice.bind(this);
        this.handleButtonsChanged = this.handleButtonsChanged.bind(this);
        this.handleCancelBtn = this.handleCancelBtn.bind(this);
        this.handleEscKeyPressed = this.handleEscKeyPressed.bind(this);

        this.addDriver = this.addDriver.bind(this);
    }

    handleEscKeyPressed(event) {
        if (event.keyCode === 27) {
            this.handleCancelBtn();
        }
    }

    componentDidMount() {
        this.searchDevices(this.state.searchString, this.state.filters);
        document.addEventListener('keydown', this.handleEscKeyPressed);
    }

    componentWillUnmount(){
        document.removeEventListener('keydown', this.handleEscKeyPressed);
    }

    onShowDevice(e, device) {

        if (e.target.type === 'checkbox') {
            return;
        }

        e.preventDefault();

        this.setState({
            showedDevice: device
        });

        this.setState({
            activeKey: device.id
        });

        //Handle double click
        if (e.detail === 2) {
            this.addDriver();
        }
    }

    handleButtonsChanged(event) {
        let filters = this.state.filters;
        //to update the active state of the button
        let buttonsActive = this.state.buttonsActive;
        switch (event.target.name) {
            case 'pc':
                buttonsActive = [true, false, false];
                if(filters.indexOf('indoor') > -1){
                    filters.splice(filters.indexOf('indoor'), 1);
                }
                if(filters.indexOf('outdoor') > -1){
                    filters.splice(filters.indexOf('outdoor'), 1);
                }
                this.setState({ 'filters': filters });
                break;
            case 'indoor':
                if(filters.indexOf('indoor') > -1){
                    break;
                }
                buttonsActive = [false, true, false];
                if(filters.indexOf('outdoor') > -1){
                    filters.splice(filters.indexOf('outdoor'), 1);
                }
                filters.push(event.target.name);
                this.setState({ 'filters': filters });
                break;
            case 'outdoor':
                if(filters.indexOf('outdoor') > -1){
                    break;
                }
                buttonsActive = [false, false, true];
                if(filters.indexOf('indoor') > -1){
                    filters.splice(filters.indexOf('indoor'), 1);
                }
                filters.push(event.target.name);
                this.setState({ 'filters': filters });
                break;
            default:
                break;
        }
        this.setState({ 'buttonsActive': buttonsActive });

        this.searchDevices(this.state.searchString, this.state.filters);
    }
    handleCancelBtn() {
        const { history } = this.props
        this.props.fetchDrivers(this.props.project.id);

        if (history) {
            if (!Object.keys(this.props.drivers)[0]) {
                this.props.deleteProject(this.props.project.id)
                    .then(() => {
                        history.push('/');
                    });

            }
        }
        this.props.handleCloseModal()
    }
    handleSearchStringChanged(event) {
        this.setState({ 'searchString': event.target.value });
        this.searchDevices(event.target.value, this.state.filters);
    }

    handleCheckBoxesChanged(event) {
        let filters = this.state.filters;

        event.target.checked ? filters.push(event.target.name) : filters.splice(filters.indexOf(event.target.name), 1);

        if (event.target.name === "latestfw")
            localStorage.setItem("latestfw", event.target.checked)

        if (event.target.name === "favouritesFilter")
            localStorage.setItem("favouritesFilter", event.target.checked)

        this.setState({ 'filters': filters });

        this.searchDevices(this.state.searchString, filters);
    }

    handleSampleDevicesChanged(event) {
        this.setState({ 'sampleDevices': event.target.checked });
        this.searchDevices(this.state.searchString, this.state.filters);
    }

    searchDevices(searchString, filters) {
        this.props.searchDevices(searchString, filters, this.state.scope)
            .then(() => {
                var favourites = JSON.parse(localStorage.getItem('favourites')) || [];
                if (this.state.filters) {

                    if (this.state.filters.includes('latestfw')
                    || this.state.filters.includes('indoor')
                    || this.state.filters.includes('outdoor')
                    || this.state.filters.includes('dali')
                    || this.state.filters.includes('otprog')
                    || this.state.filters.includes('nfc')
                    || this.state.filters.includes('inv')
                    ) {
                        this.setState({ 'devices': this.props.devices });
                    }

                    if (this.state.filters.includes('favouritesFilter')) {
                        this.setState({
                            'devices':
                                this.props.devices.filter( device => favourites.some( favorite => favorite.xmlRef === device.xmlRef ) )
                        })
                    }

                }

                if (filters.length === 0) {
                    this.setState({ 'devices': this.props.devices })
                }
            });
    }

    cancelSelectedDevice() {
        this.setState({
            showedDevice: null
        });

        this.setState({
            activeKey: 0,
        });
    }

    addDriver() {
        //start loader
        this.setState({ loader: true });

        this.props.addDriver(this.props.project.id, this.state.showedDevice)
            .then(() => {
                //stop loader
                this.setState({ loader: false });

                this.props.handleCloseModal();
                //If there is an error on adding a driver do not reload the page in order to see the error message
                if (!this.props.errors[0]) {
                    window.location.reload();
                }
            })
            .catch(() => {
                //stop loader
                this.setState({ loader: false });
            });
    }

    render() {

        return (
            <Modal show={this.props.isShowed} onHide={() => this.props.handleCloseModal()} animation={false} dialogClassName="modal-75w" backdrop='static'>
                {/* <Modal.Header closeButton> */}
                <Modal.Header style={{ padding: "0.5rem 1rem" }}>
                    <Modal.Title style={{ color: "#FF6600" }}><Trans i18nKey="Select_Device" /></Modal.Title>
                </Modal.Header>

                <Modal.Body className={'modal-body-device-select'}>
                    <Row className={this.state.loader ? 'card-disabled' : ''}>
                        {/* List of devices */}
                        <Col sm={6} >
                            <ButtonToolbar>
                                <Button name="pc" active={this.state.buttonsActive[0]} variant="outline-primary" className="btn-device-select" onClick={this.handleButtonsChanged}><Trans i18nKey="SHOW_ALL" /></Button>
                                <Button name="indoor" active={this.state.buttonsActive[1]} variant="outline-primary" className="btn-device-select" onClick={this.handleButtonsChanged}><Trans i18nKey="INDOOR_ONLY" /></Button>
                                <Button name="outdoor" active={this.state.buttonsActive[2]} variant="outline-primary" className="btn-device-select" onClick={this.handleButtonsChanged}><Trans i18nKey="OUTDOOR_ONLY" /></Button>
                            </ButtonToolbar>

                            <input type="text" className="search-device-select" placeholder={this.props.t("Search")} onChange={this.handleSearchStringChanged.bind(this)} />

                            <Tabs defaultActiveKey="All">
                                <Tab eventKey="All" title={this.props.t("All")}>
                                    <DeviceList
                                        devices={this.state.devices}
                                        activeKey={this.state.activeKey}
                                        onShowDevice={this.onShowDevice.bind(this)} />
                                </Tab>
                                {/* <Tab eventKey="Favorites" title={
                                <span>
                                    <FontAwesomeIcon size='1x' icon={faStar} />
                                    &nbsp;
                                    Favorites
                                </span>}>
                                <DeviceList
                                    //devices.favorites
                                    devices={this.state.devices}
                                    activeKey={this.state.activeKey}
                                    onShowDevice={this.onShowDevice.bind(this)} />
                            </Tab> */}
                            </Tabs>
                        </Col>
                        {/* Settings of devices */}
                        <Col sm={6} >
                            <div>
                                <div className="settings-header-device-select">
                                    <b><Trans i18nKey="Advanced_filters" /></b>
                                </div>
                                <div className="m5-device-select">
                                    <Row>
                                        <Col sm={3}>
                                            <Trans i18nKey="Programming_Interface" />
                                        </Col>
                                        <Col sm={2}>
                                            <Form>
                                                <Form.Check
                                                    label="DALI"
                                                    name="dali"
                                                    type="checkbox"
                                                    onChange={this.handleCheckBoxesChanged.bind(this)} />
                                            </Form>
                                        </Col>
                                        <Col sm={2}>
                                            <Form>
                                                <Form.Check
                                                    label="OT Prog."
                                                    name="otprog"
                                                    type="checkbox"
                                                    onChange={this.handleCheckBoxesChanged.bind(this)} />
                                            </Form>
                                        </Col>
                                        <Col sm={2}>
                                            <Form>
                                                <Form.Check
                                                    label="NFC"
                                                    name="nfc"
                                                    type="checkbox"
                                                    onChange={this.handleCheckBoxesChanged.bind(this)} />
                                            </Form>
                                        </Col>
                                        <Col sm={2}>
                                            <Form>
                                                <Form.Check
                                                    label="PRG-MUL2"
                                                    name="inv"
                                                    type="checkbox"
                                                    onChange={this.handleCheckBoxesChanged.bind(this)} />
                                            </Form>
                                        </Col>
                                    </Row>
                                    {/* <Row>
                                        <Col sm={4}>
                                            <p> Show sample devices </p>
                                        </Col>
                                        <Col sm={2}>
                                            <Form>
                                                <Form.Check
                                                    name="sampleDevices"
                                                    type="checkbox"
                                                    onChange={this.handleSampleDevicesChanged.bind(this)} />
                                            </Form>
                                        </Col>
                                    </Row> */}
                                </div>
                                <div className="test">
                                    <Form>
                                        <Form.Check
                                            label={<Trans i18nKey="Show_only_newest_FW_versions" />} //"Show only newest FW versions"
                                            name="latestfw"
                                            type="checkbox"
                                            defaultChecked={false}
                                            onChange={this.handleCheckBoxesChanged.bind(this)} />
                                        <Form.Check
                                            label={<Trans i18nKey="Show_only_favourites" />} //"Show only favourites"
                                            name="favouritesFilter"
                                            type="checkbox"
                                            defaultChecked={false}
                                            onChange={this.handleCheckBoxesChanged.bind(this)} />
                                    </Form>
                                </div>
                            </div>
                            <div>
                                <div className="settings-header-device-select">
                                    <b><Trans i18nKey="Selection" /></b>
                                </div>
                                <DeviceImage device={this.state.showedDevice} as={Row} />
                            </div>
                        </Col >
                    </Row>
                </Modal.Body>

                <Modal.Footer style={{ padding: '0.5rem' }}>
                    {/* {
                        this.state.showedDevice
                            ?
                            <Button variant="primary" onClick={this.addDriver}>Select</Button>
                            :
                            <Button variant="primary" onClick={this.addDriver} disabled>Select</Button>
                    } */}
                    <Button variant="primary" onClick={
                        this.handleCancelBtn

                    }>
                        {
                            <div>
                                <Trans i18nKey="Cancel" />
                            </div>
                        }
                    </Button>
                    <Button variant="primary" onClick={this.addDriver} disabled={(this.state.showedDevice || this.state.loader) ? null : 'disabled'}>
                        {this.state.loader ?
                            <div>
                                <Spinner
                                    style={{ marginRight: "0.25rem" }}
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                <Trans i18nKey="Adding_Driver" />
                            </div>

                            :

                            <div>
                                <Trans i18nKey="Select" />
                            </div>
                        }
                    </Button>

                    {/* <Button variant="secondary" onClick={() => this.props.handleCloseModal()}>Cancel</Button> */}
                </Modal.Footer>
            </Modal >
        );
    };
};

const mapStateToProps = (state) => {
    return {
        devices: state.devices,
        project: state.project.info,
        projectIsTemporary: state.project.isTemporary,
        errors: state.errorsHandler.errors,
        drivers: state.drivers
    };
};

const mapDispatchToProps = {
    fetchDevices,
    searchDevices,
    addDriver,
    fetchDrivers,
    verifyProject,
    deleteProject
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation()(DeviceSelect)));
